import { IllustrationProps } from "types/Illustration";

export const EditIcon = ({ fill }: IllustrationProps) => (
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 12.0008H2.5L9.87333 4.62748L7.37333 2.12748L0 9.50081V12.0008ZM1.33333 10.0541L7.37333 4.01415L7.98667 4.62748L1.94667 10.6675H1.33333V10.0541Z"
      fill={fill}
    />
    <path
      d="M10.2467 0.194145C9.98667 -0.0658545 9.56667 -0.0658545 9.30667 0.194145L8.08667 1.41415L10.5867 3.91415L11.8067 2.69415C12.0667 2.43415 12.0667 2.01415 11.8067 1.75415L10.2467 0.194145Z"
      fill={fill}
    />
  </svg>
);
